import { Component, OnInit, inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';

import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { environment } from 'src/environments/environment';
import { SharedService } from './services/shared.service';

/**
 * Main App Module
 * @class AppComponent
 * @typedef {AppComponent}
 * @implements {OnInit}
 */
@Component( {
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
} )
export class AppComponent implements OnInit {
    /**
     * isProduction enviroment check
     * @type {*}
     */
    showMatomoConsent = environment.optionalModules.showMatomoConsent;

    /**
     * Router Injection
     * @type {*}
     */
    #router = inject( Router );
    /**
     * Shared Service Injection
     * @type {*}
     */
    #sharedService = inject( SharedService );

    /**
     * Instance of tracker Subscription
     * @type {*}
     */
    trackerSubscription = new Subscription();

    /**
     * skip2main
     * @type {string}
     */
    skip2main = '';
    /**
     * skip2footer
     * @type {string}
     */
    skip2footer = '';

    constructor() {
        if ( environment.production ) {
            var angularPlugin: any = new AngularPlugin();
            const appInsights = new ApplicationInsights( {
                config: {
                    connectionString: environment.azure.applicationInsights,
                    extensions: [angularPlugin],
                    extensionConfig: {
                        [angularPlugin.identifier]: { router: this.#router }
                    }
                }
            } );
            appInsights.loadAppInsights();
        }
    }

    ngOnInit() {
        /**
         * listen on router events
         *
         * when navigation is done, then create skip links dynamically
         * and trigger cookie consent in production mode
         */
        this.#router.events
            .pipe(
                filter(
                    ( event ) =>
                        event instanceof NavigationStart ||
                        event instanceof NavigationEnd ||
                        event instanceof NavigationCancel ||
                        event instanceof NavigationError
                )
            )
            .subscribe( ( event ) => {
                /** contruct skip links */
                if ( event instanceof NavigationEnd ) {
                    let currentUrl = this.#router.url;
                    const hashIndex = currentUrl.indexOf( '#' );
                    if ( hashIndex > 0 ) currentUrl = currentUrl.slice( 0, hashIndex );

                    this.skip2main = currentUrl + '#main';
                    this.skip2footer = currentUrl + '#footer';
                }

                const checked = this.#sharedService.consentChecked();
                if ( this.showMatomoConsent && !checked && event instanceof NavigationEnd ) {
                    this.manageCookies();
                }
            } );
    }

    /** helper function to show consent banner */
    manageCookies() {
        this.#sharedService.handleTrackingConsent( true );
    }
}
